import { render } from "./ProjectGallery.vue?vue&type=template&id=225cec98&scoped=true"
import script from "./ProjectGallery.vue?vue&type=script&lang=js"
export * from "./ProjectGallery.vue?vue&type=script&lang=js"

import "./ProjectGallery.vue?vue&type=style&index=0&id=225cec98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225cec98"]])

export default __exports__